import { render } from "./patients_pending_view_tab.vue?vue&type=template&id=be8269e6"
import script from "./patients_pending_view_tab.vue?vue&type=script&lang=js"
export * from "./patients_pending_view_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__